import { render, staticRenderFns } from "./ConversationsList.vue?vue&type=template&id=c831a39c&"
import script from "./ConversationsList.vue?vue&type=script&lang=ts&"
export * from "./ConversationsList.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports